import {ChangeDetectionStrategy,Component,inject,input} from '@angular/core';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {RouterLink} from '@angular/router';
import {NgOptimizedImage} from '@angular/common';
import {MatDrawer} from '@angular/material/sidenav';
import {AppService} from '../../../app.service';

@Component({
	selector:'app-header',
	imports:[MatToolbarModule,MatIconModule,MatButtonModule,RouterLink,NgOptimizedImage],
	templateUrl:'./header.html',
	styleUrl:'./header.scss',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class HeaderComponent{
	readonly drawerInput=input<MatDrawer>();
	readonly appService=inject(AppService);
}
